export default __webpack_public_path__ + "static/media/intro5.7bb36de6.mp3";